<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled" [compareWith]="compareById">
  @if (showAllOption()) {
    <nb-option [value]="undefined">Alle</nb-option>
  }
  @let fallback = fallbackAction;
  @if (fallback) {
    <nb-option [value]="fallback">{{ fallback.name }}</nb-option>
  }
  @if (recommendedValue) {
    <nb-option [value]="recommendedValue">
      {{recommendedValue.name}}
      <nb-icon icon="flash" pack="eva" status="info" nbTooltip="Empfohlen durch Feststellung" nbTooltipStatus="info"></nb-icon>
    </nb-option>
  }
  @for (action of actionsWithoutRecommended; track action.id) {
    <nb-option [value]="action">
      {{action.name}}
    </nb-option>
  }
</nb-select>
